import { render, staticRenderFns } from "./imageView.vue?vue&type=template&id=f83b1344"
import script from "./imageView.vue?vue&type=script&lang=js"
export * from "./imageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports